import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const services = [
  {
    title: "Annual Impact Reports: ",
    details:
      "Comprehensive summaries of project outcomes, metrics, and financial allocations, highlighting the measurable difference made through funders' contributions.",
  },
  {
    title: "Quarterly Updates and Funder-Grantee Townhall meetings: ",
    details:
      "Regular updates on ongoing projects, key milestones, and strategic developments.",
  },
  {
    title: "Interactive Dashboards:",
    details:
      "Future plans to provide funders with access to real-time data on funded initiatives, enabling informed decision-making.",
  },
];

const Transparency = () => {
  return (
    <Box
      margin={{ xs: "35% 0% 10% 0%", sm: "5% 0% 0% 0%" }}
      data-aos={"fade-down"}
    >
      <Typography
        variant="h3"
        fontWeight={700}
        paddingBottom={{ xs: "6%", sm: "4%" }}
        textAlign={"left"}
        color={"#39484E"}
      >
        {" "}
        Transparency Commitment
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        // alignItems={"center"}
        flexWrap={"wrap"}
        width={"100%"}
      >
        <Box
          width={{ xs: "100%", sm: "48%" }}
          paddingRight={{ xs: "0%", sm: "4%" }}
        >
          <Typography
            variant="h4"
            fontWeight={700}
            paddingBottom={{ xs: "4%", sm: "2%" }}
            textAlign={"left"}
            color={"#39484E"}
          >
            {" "}
            AIR Fund values accountability and transparency, ensuring funders
            can track their contributions' impact. Our robust reporting
            mechanisms include:
          </Typography>
        </Box>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          color={"#39484E"}
        />
        <Box
          width={{ xs: "100%", sm: "48%" }}
          paddingLeft={{ xs: "0%", sm: "4%" }}
          paddingTop={{ xs: "0%", sm: "2%" }}
        >
          {services.map((data, index) => (
            <Box display={"flex"} alignItems={"flex-start"} key={index}>
              <Typography
                variant="h4"
                fontWeight={700}
                paddingRight={"4%"}
                textAlign={"left"}
                color={"#948979"}
              >
                {" "}
                &#8226;
              </Typography>

              <Typography
                variant="body1"
                fontWeight={400}
                paddingBottom={{ xs: "4%", sm: "2%" }}
                textAlign={"left"}
                color={"#000"}
              >
                <Typography
                  component={"span"}
                  variant="body1"
                  fontWeight={700}
                  paddingBottom={{ xs: "4%", sm: "2%" }}
                  textAlign={"left"}
                  color={"#213555"}
                >
                  {data.title}{" "}
                </Typography>
                {data.details}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Transparency;
